webpackJsonp([166022755830701],{

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(121);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PlayerPage = function (_Component) {
	  _inherits(PlayerPage, _Component);
	
	  function PlayerPage() {
	    _classCallCheck(this, PlayerPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PlayerPage.prototype.componentDidMount = function componentDidMount() {
	    console.log(location);
	    var queryString = location.search;
	    queryString = queryString.replace("movie_id", "video_id");
	    var params = _queryString2.default.parse(queryString);
	    var videoId = params["video_id"];
	    if (!videoId) {
	      location.replace('/404.html');
	    }
	    var episodeId = void 0;
	    var videos = this.props.data.allVideo.edges.map(function (edge) {
	      return edge.node;
	    });
	    videos.forEach(function (video) {
	      if (video.videoId === Number.parseInt(videoId)) {
	        episodeId = video.episodeId;
	      }
	    });
	    if (episodeId) {
	      location.replace('/episode/' + episodeId + queryString);
	    } else {
	      location.replace('/404.html');
	    }
	  };
	
	  PlayerPage.prototype.render = function render() {
	    return _react2.default.createElement('div', null);
	  };
	
	  return PlayerPage;
	}(_react.Component);
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = PlayerPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-player-js-4b0cf4f1819efdf4499d.js